import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChartConfiguration, ChartOptions } from "chart.js";
import { NgChartsModule } from "ng2-charts";

@Component({
  selector: "app-issues-chart",
  standalone: true,
  imports: [NgChartsModule, CommonModule],
  templateUrl: "./issues-chart.component.html",
  styleUrls: ["./issues-chart.component.scss"]
})
export class IssuesChartComponent implements OnChanges {
  @Input() minor: number = 0;
  @Input() major: number = 0;
  @Input() missing: number = 0;

  chartType: "doughnut" = "doughnut" as const;

  total: number = 0;

  chartData: ChartConfiguration<"doughnut">["data"] = {
    labels: [],
    datasets: []
  };

  chartOptions: ChartOptions<"doughnut"> = {
    cutout: "85%",
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false }
    }
  };

  ngOnChanges(_: SimpleChanges): void {
    this.total = this.minor + this.major + this.missing;

    this.chartData = {
      labels: [
        `Minor ${this.pad(this.minor)}`,
        `Major ${this.pad(this.major)}`,
        `Missing ${this.pad(this.missing)}`
      ],
      datasets: [
        {
          data: [this.minor, this.major, this.missing],
          backgroundColor: [
            getComputedStyle(document.documentElement).getPropertyValue("--yellow-500")
              .trim(),
            getComputedStyle(document.documentElement).getPropertyValue("--warning-500")
              .trim(),
            getComputedStyle(document.documentElement).getPropertyValue("--blue-200")
              .trim()
          ],
          borderWidth: 0,
          hoverOffset: 10
        }
      ]
    };
  }

  pad(val: number): string {
    return val < 10 ? `0${val}` : `${val}`;
  }
}
